import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'


import About from '@/components/About'
import Login from '@/components/Login'
import MessagesInbox from '@/components/MessagesInbox'
import Devices from '@/components/Devices'
import DeviceCommands from '@/components/DeviceCommands'

import Contacts from '@/components/Contacts'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Default',
      component: Home
    },  
    

    {
      path: '/about',
      name: 'About',
      component: About
    }
    ,    
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
    ,    
    {
      // path: '/MessagesInbox/:id',
      path: '/MessagesInbox',
      name: 'MessagesInbox',
      component: MessagesInbox
      // ,      
      // props: { default: true, sidebar: false }
    },
    ,    
    {
      path: '/devices',
      name: 'Devices',
      component: Devices
    },
    {
      path: '/Contacts',
      name: 'Contacts',
      component: Contacts
    }
    ,
    {
      path: '/devicecommands',
      name: 'DeviceCommands',
      component: DeviceCommands
    }
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js